import { render, staticRenderFns } from "./ExclusiveProactive.vue?vue&type=template&id=2b992780"
import script from "./ExclusiveProactive.vue?vue&type=script&lang=js"
export * from "./ExclusiveProactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports